import Box from '@mui/material/Box'
import Skeleton from '@mui/material/Skeleton'
import { selectBrandGridSx } from '@/features/rewards/styles/selectBrandStyles'
import { skeletonBusyProps, skeletonRoundedSx } from './skeletonCommon'

interface Props {
  readonly testId?: string
  readonly count?: number
}

function BrandCardSkeleton() {
  return (
    <Box
      sx={{
        bgcolor: '#fff',
        border: '1px solid #e8edf2',
        borderRadius: '16px',
        p: 2,
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
      }}
    >
      <Skeleton variant="rounded" width={56} height={54} sx={{ borderRadius: '8px' }} />
      <Skeleton variant="rounded" width="70%" height={22} sx={{ borderRadius: '6px' }} />
      <Skeleton variant="rounded" width="90%" height={16} sx={{ borderRadius: '6px' }} />
      <Skeleton variant="rounded" width="100%" height={36} sx={{ ...skeletonRoundedSx, mt: 0.5 }} />
    </Box>
  )
}

export function BrandGridSkeleton({
  testId = 'rewards-brand-grid-skeleton',
  count = 6,
}: Readonly<Props>) {
  return (
    <Box
      data-testid={testId}
      {...skeletonBusyProps}
      aria-label="Loading brands"
      sx={selectBrandGridSx}
    >
      {Array.from({ length: count }, (_, i) => (
        <BrandCardSkeleton key={i} />
      ))}
    </Box>
  )
}
